import { Button } from '@chakra-ui/react';
import React, { useState, useEffect } from 'react';
import { IoMdClose } from 'react-icons/io';
import { useCartContext } from '../../context/cart_context';
import { useFilterContext } from '../../context/filter_context';
import axios from 'axios';
import { useUserContext } from '../../context/user_context';
import { Link, useHistory } from 'react-router-dom';
import Loading from '../Loading';
import { toast } from 'react-toastify';
import StripeCheckout from '../StripeCheckout';
const CartPopup = ({ onClose, closeSidebar }) => {
  const { addToCart, total_amount, removeItem, cart, toggleAmount } = useCartContext();
  const [cartData, setCartData] = useState([]);
  const { filtered_products: products, grid_view } = useFilterContext();
  const { currentUser } = useUserContext();
  const [isLoading, setIsLoading] = useState(false);
  const [isOpenCheckout, setIsOpenCheckout] = useState(false);
  const history = useHistory();
  const handleRemove = async (id) => {
    const data = {
      wishlistItem: id,
    };
    const userid = currentUser?.id;
    const response = await axios.delete(
      `${process.env.REACT_APP_BACKEND_HOST}/api/user/addtocart/${userid}`,
      { data }
    );
    fetchData();
  };

  useEffect(() => {
    setCartData(cart);
  }, [cart]);
  const fetchData = async () => {
    setIsLoading(true);
    try {
      const userid = currentUser?.id;
      if (userid) {
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_HOST}/api/user/addtocart/${userid}`
        );
        const array = response.data.data;
        let data = [];
        const filteredItems = products.map((product) => {
          if (array.length > 0 && array.filter((e) => e?.id == product?.id)) {
            data?.push(product);
          }
        });
        setIsLoading(false);
      }
    } catch (error) {
      console.error('Error fetching wishlist items:', error);
    }
    setIsLoading(false);
  };

   
  const handleCancel = () => {
    history.push('/cart');
  };
  const handleWishlistButton = async (id) => {
    let userid = currentUser.id;
    if (currentUser) {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_HOST}/api/user/wishlistitem/${userid}`
      );
      const array = response?.data?.data || [];

      let isPresent = array?.includes(id);
      let options = { wishlistItem: Number(id) };
      if (!isPresent) {
        try {
          let res = await axios.put(
            `${process.env.REACT_APP_BACKEND_HOST}/api/user/wishlistitem/${userid}`,
            { id }
          );
          toast.success('Item added to wishlist');
        } catch (error) {
          console.error('Error adding item to wishlist:', error);
        }
      } else {
        try {
          const data = {
            wishlistItem: id,
          };
          const userid = currentUser?.id;
          const response = await axios.delete(
            `${process.env.REACT_APP_BACKEND_HOST}/api/user/wishlistitem/${userid}`,
            { data }
          );

          toast.success('Item removed from wishlist');
        } catch (error) {
          console.error('Error deleting item from wishlist:', error);
        }
      }
    }
  };

  const handleMovetoWishlist = async (id) => {
    await removeItem(id);
    handleWishlistButton(id);
  };

  const handleDecrease = (id) => {
    toggleAmount(id, 'dec');
  };

  const handleIncrease = (id) => {
    toggleAmount(id, 'inc');
  };

  const handleCheckout=()=>{
    closeSidebar()
    onClose()
    history.push("/cart")
  }
  return !isOpenCheckout ? (
    <div
      className='flex flex-col bg-white rounded-lg  
      w-[90vw] sm:w-[400px] md:w-[420px] max-h-[70vh] overflow-y-auto p-4 z-[50]'
    >
      <h1 className='text-black font-semibold text-lg mb-4 text-center sm:text-left'>
        Your Bag <span className='text-[#008FAB]'>({cartData?.length})</span>
      </h1>

      {!isLoading && (
        <div className='flex flex-col gap-4'>
          {cartData?.map((e, index) => (
            <div
              key={e.id}
              className='border-b border-[#008FAB40] pb-3 last:border-none'
            >
              <div className='flex gap-3 sm:gap-4 items-center justify-between'>
                <img
                  src={e?.image?.length > 0 ? e?.image[0] : ''}
                  alt={e?.name}
                  className='w-16 h-16 sm:w-20 sm:h-20 rounded-md object-cover'
                />

                <div className='flex-1 flex flex-col text-sm sm:text-base'>
                  <div className='flex items-center justify-between'>
                    <p className='font-medium text-gray-800 line-clamp-2 leading-tight'>
                      {e?.description}
                    </p>
                    <IoMdClose
                      className='text-[#008FAB] cursor-pointer text-lg sm:text-xl hover:text-red-500 transition'
                      onClick={() => handleRemove(e?.id)}
                    />
                  </div>
                  <div className='flex gap-2 items-center mt-1 text-xs'>
                    <p className='relative'>Quantity</p>
                  </div>
                  <div className='flex justify-between'>
                    <div className='flex border gap-3 justify-center items-center'>
                      <button
                        className='px-2 py-1 text-blue-300'
                        onClick={() => handleDecrease(cart[index]?.id)}
                      >
                        -
                      </button>
                      <span className='px-2 text-blue-300'>
                        {cart[index]?.amount}
                      </span>
                      <button
                        className='px-2 py-1 text-blue-300'
                        onClick={() => handleIncrease(cart[index]?.id)}
                      >
                        +
                      </button>
                    </div>
                    <p>Rs{Number(e?.price * cart[index]?.amount)}</p>
                  </div>
                  <p
                    className='underline cursor-pointer'
                    onClick={() => handleMovetoWishlist(e.id)}
                  >
                    Save for later
                  </p>
                </div>
              </div>
              <div className='border border-[#008FAB] w-full px-2 mt-4'></div>
            </div>
          ))}
        </div>
      )}
      {isLoading && <Loading />}
      <div className='flex justify-between text-black text-xl font-bold'>
        <h1>Total</h1>
        <h1>Rs{Math.round(total_amount)}</h1>
      </div>
      <p className='text-[#222222] text-sm'>
        Shipping, gift cards and promo codes applied at checkout.
      </p>

      {cartData.length > 0 && (
        <Button
          backgroundColor={'#D3A143'}
          textColor={'white'}
          onClick={handleCheckout}
        >
          View Cart Page
        </Button>
      )}
    </div>
  ) : (
    <StripeCheckout onCancel={handleCancel} />
  );
};

export default CartPopup;
